export const UserDetailsAdministrationTabsEnum = Object.freeze({
  GROUPS: 'GROUPS',
  ROLES_AND_RIGHTS: 'ROLES_AND_RIGHTS',
  LOCK_USER: 'LOCK_USER',
  USER_DATA: 'USER_DATA',
  RESPONSE_HISTORY: 'RESPONSE_HISTORY',
});
